import { Badge } from '@/components';
import { CommerceShippingListItem } from '@/pages/BusinessCommerces/services/commerceShippings.service';

interface BadgeColors {
  bg: string;
  text: string;
}

const SERVICE_COLORS: BadgeColors[] = [
  { bg: '#E3F2FD', text: '#1565C0' },
  { bg: '#E8F5E9', text: '#2E7D32' },
  { bg: '#F3E5F5', text: '#6A1B9A' },
  { bg: '#FFF3E0', text: '#EF6C00' },
  { bg: '#E0F7FA', text: '#00838F' },
  { bg: '#FCE4EC', text: '#AD1457' },
  { bg: '#EDE7F6', text: '#4527A0' },
  { bg: '#FFFDE7', text: '#F57F17' },
];

const NEUTRAL: BadgeColors = { bg: '#E0E0E0', text: '#616161' };

const pickColor = (seed: string): BadgeColors => {
  let hash = 5381;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 33) ^ seed.charCodeAt(i);
  }
  return SERVICE_COLORS[Math.abs(hash) % SERVICE_COLORS.length];
};

const capitalize = (value: string): string =>
  value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

const renderService = (
  value: string | null,
  rowData: CommerceShippingListItem
): JSX.Element => {
  const serviceName = value?.trim();

  if (!serviceName) {
    return (
      <div className='w-fit'>
        <Badge
          value='Sin servicio'
          density='compact'
          backgroundColor={NEUTRAL.bg}
          textColor={NEUTRAL.text}
          ballColor={NEUTRAL.text}
        />
      </div>
    );
  }

  const colors = pickColor(
    rowData?.serviceWithOperatorId?.trim() || serviceName
  );

  return (
    <div className='w-fit max-w-[220px]'>
      <Badge
        value={capitalize(serviceName)}
        density='compact'
        backgroundColor={colors.bg}
        textColor={colors.text}
        ballColor={colors.text}
      />
    </div>
  );
};

export default renderService;
